import { Injectable } from '@angular/core';
import { LOCALLY_HOSTED } from '../common/setup';

const VERSION = 1;

@Injectable()
export class IndexedDBService {

    private db: IDBDatabase;
    private dbName = 'servitlyOfflineDB';
    private storeName = 'apiResponse';

    static DB_NOT_REFRENCED_ERROR = 'IndexedDB not referenced';

    constructor() {
        if (LOCALLY_HOSTED) {
            this.init();
        }
    }

    init(): Promise<void> {
        if (this.db) {
            return Promise.resolve();
        }
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(this.dbName, VERSION);
            request.onerror = () => reject(`Error on opening IndexedDB: ${request.error}`);
            request.onsuccess = () => {
                this.db = request.result;
                resolve();
            };
            request.onupgradeneeded = () => {
                this.db = request.result;
                if (!this.db.objectStoreNames.contains(this.storeName)) {
                    this.db.createObjectStore(this.storeName);
                }
            };
        });
    }

    save(url: string, data: any): Promise<void> {
        return new Promise((resolve, reject) => {
            if (!this.db) {
                reject(IndexedDBService.DB_NOT_REFRENCED_ERROR);
            }
            const tx = this.db.transaction(this.storeName, 'readwrite');
            const store = tx.objectStore(this.storeName);
            store.put(data, url);
            tx.oncomplete = () => resolve();
            tx.onerror = () => reject(tx.error);
        });
    }

    get(url: string): Promise<any> {
        return new Promise((resolve, reject) => {
            if (!this.db) {
                reject(IndexedDBService.DB_NOT_REFRENCED_ERROR);
            }
            const tx = this.db.transaction(this.storeName, 'readonly');
            const store = tx.objectStore(this.storeName);
            const request = store.get(url);
            request.onsuccess = () => resolve(request.result || null);
            request.onerror = () => reject(request.error);
        });
    }

}